import React, { Dispatch, FC, SetStateAction } from 'react'
import { UnscheduledTasksFormName, useUnscheduledTasks } from '../context/UnscheduledTasksContext'
import UnscheduledTaskList from '../components/UnscheduledTasksList'
import { TaskPanelRedirectionParameters } from '../services/schedule.types'

type UnscheduledTasksListContainerProps = {
	isResultat: boolean
	setTaskPanelRedirectionParameters: Dispatch<SetStateAction<TaskPanelRedirectionParameters | undefined>>
}

const UnscheduledTasksListContainer: FC<UnscheduledTasksListContainerProps> = ({ isResultat, setTaskPanelRedirectionParameters }) => {
	const { handleQuery, query } = useUnscheduledTasks()

	return (<UnscheduledTaskList
		onSubmit={handleQuery}
		form={UnscheduledTasksFormName}
		query={query}
		isResultat={isResultat}
		setTaskPanelRedirectionParameters={setTaskPanelRedirectionParameters}
	/>)
}

export default UnscheduledTasksListContainer

